module.exports = __webpack_public_path__ + "static/img/302_TO8_2005.2ac5c4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/302_TO8_2005.jpg
// module id = c+QE
// module chunks = 0